import { render } from "./Child-List-Item.vue?vue&type=template&id=273a7896&scoped=true"
import script from "./Child-List-Item.vue?vue&type=script&lang=js"
export * from "./Child-List-Item.vue?vue&type=script&lang=js"

import "./Child-List-Item.vue?vue&type=style&index=0&id=273a7896&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-273a7896"]])

export default __exports__